import { SmsNotificationsModal } from './SmsNotificationsModal';

const source = 'ad-hoc';

export const SmsNotificationsPrompt = (props: {
  setLastReminded: (newValue: string | null) => void;
}) => (
  <SmsNotificationsModal
    source={source}
    isAdhoc={true}
    onClose={() => props.setLastReminded(new Date().toISOString())}
  />
);
